export const RATE_TYPE = {
  HOURLY: 1,
  ANNUAL: 2,
} as const;
